export default __webpack_public_path__ + "static/media/small_josh.54fc2c97.png";